import { ALLOWED_FEATURES } from '@atlassian/embedded-confluence-common/features';

export const VIEW_PAGE_FEATURES = ALLOWED_FEATURES.view;
export const EDIT_PAGE_FEATURES = ALLOWED_FEATURES.edit;
export const WHITEBOARD_FEATURES = ALLOWED_FEATURES.whiteboard;

export {
	DEFAULT_ALLOWED_FEATURES,
	getAllowedFeatures,
} from '@atlassian/embedded-confluence-common/features';

export type {
	AllowedFeatures,
	AnyAllowedFeatures,
	PageAllowedFeatures,
	ParsedPageAllowedFeatures,
} from '@atlassian/embedded-confluence-common/features';
